// 宮崎県ローカルテレビクイズ - 10問1セット×10セット

import { quizData } from './quizData';

export const quizSets = [
  {
    id: 1,
    title: "セット1: 放送局の基本 (前半)",
    category: "放送局の基本",
    questions: quizData.slice(0, 10)
  },
  {
    id: 2,
    title: "セット2: 放送局の基本 (後半)",
    category: "放送局の基本",
    questions: quizData.slice(10, 20)
  },
  {
    id: 3,
    title: "セット3: 歴史と歩み (前半)",
    category: "歴史と歩み",
    questions: quizData.slice(20, 30)
  },
  {
    id: 4,
    title: "セット4: 歴史と歩み (後半)",
    category: "歴史と歩み",
    questions: quizData.slice(30, 40)
  },
  {
    id: 5,
    title: "セット5: 看板番組 (第1弾)",
    category: "看板番組",
    questions: quizData.slice(40, 50)
  },
  {
    id: 6,
    title: "セット6: 看板番組 (第2弾)",
    category: "看板番組",
    questions: quizData.slice(50, 60)
  },
  {
    id: 7,
    title: "セット7: 看板番組 (第3弾)",
    category: "看板番組",
    questions: quizData.slice(60, 70)
  },
  {
    id: 8,
    title: "セット8: 人気パーソナリティ",
    category: "人気パーソナリティ",
    questions: quizData.slice(65, 75)
  },
  {
    id: 9,
    title: "セット9: 超マニアック (前半)",
    category: "超マニアック",
    questions: quizData.slice(80, 90)
  },
  {
    id: 10,
    title: "セット10: 超マニアック (後半)",
    category: "超マニアック",
    questions: quizData.slice(90, 100)
  }
];

// 全クイズデータを1つの配列にまとめたもの（既存のコードとの互換性のため）
export const allQuizData = quizSets.flatMap(set => set.questions);
